import React from 'react';
import { DASHBOARD_DISPLAY_NAME } from '@utils/constants';
import NameLink from '../NameLink';
import Timestamp from '../Timestamp';
import DashboardListOptionsMenu from '../DashboardListOptionsMenu';

const Pulse5PublicDashboardColumns = [
  {
    title: 'Dashboard',
    dataKey: 'name',
    key: 'name',
    width: 460,
    sortable: true,
    resizable: true,
    cellRenderer: ({ rowData }) => {
      const { id, name, productName, dashboardType } = rowData;
      return (
        <NameLink id={id} name={name} productName={productName} dashboardType={dashboardType} />
      );
    },
  },
  {
    title: 'Saved From',
    dataKey: 'savedFrom',
    key: 'savedFrom',
    width: 200,
    sortable: true,
    resizable: true,
    cellRenderer: ({ rowData }) => {
      const {
        dashboardType: { id },
      } = rowData;
      return <div>{DASHBOARD_DISPLAY_NAME[id]}</div>;
    },
  },
  {
    title: 'Updated By',
    dataKey: 'updatedBy',
    key: 'updatedBy',
    width: 250,
    sortable: true,
    resizable: true,
    cellRenderer: ({ cellData: updatedBy }) =>
      updatedBy && updatedBy.length ? updatedBy : <div style={{ marginLeft: '10px' }}>-</div>,
  },
  {
    title: 'Last Updated On',
    dataKey: 'updatedAt',
    key: 'updatedAt',
    width: 170,
    sortable: true,
    resizable: true,
    cellRenderer: ({ cellData: time, rowData }) =>
      time && time !== '-' && rowData.updatedBy.length ? (
        <Timestamp timestamp={time} />
      ) : (
        <div style={{ marginLeft: '10px' }}>-</div>
      ),
  },
  {
    title: 'Created By',
    dataKey: 'createdBy',
    key: 'createdBy',
    width: 250,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Created On',
    dataKey: 'createdAt',
    key: 'createdAt',
    width: 170,
    sortable: true,
    resizable: true,
    cellRenderer: ({ cellData: time }) =>
      time && time !== '-' ? <Timestamp timestamp={time} /> : '-',
  },

  {
    title: 'Actions',
    dataKey: '',
    key: 'menu-options',
    sortable: false,
    resizable: true,
    align: 'left',
    flexGrow: 1,
    width: 190,
    cellRenderer: ({ rowData }) => {
      return <DashboardListOptionsMenu rowData={rowData} />;
    },
  },
];

export default Pulse5PublicDashboardColumns;
